import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './OrderSection.scss';

interface IOwnProps {
  borderBottom?: boolean;
  blockFor?: string;
}

const OrderSection: React.SFC<IOwnProps> = ({ children, borderBottom = true, blockFor }) => {
  const sectionClassNames = cx({
    [Styles.section]: true,
    [Styles.borderBottom]: borderBottom
  });

  return (
    <div className={sectionClassNames} data-block-for={blockFor}>
      <div className={Styles.content}>
        {children}
      </div>
    </div>
  );
};

export default OrderSection;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/OrderSection/OrderSection.tsx